import {
  AsyncResult,
  callActionOrExecute,
  DataServiceQuery,
  IContext,
  IDataServiceRequest,
} from "@msdyn365-commerce/retail-proxy";
import * as AtpDataServiceEntities from "./AtpDataServiceEntities.g";

function lTSGetATPDatesQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function lTSGetATPDatesInput(
  atpItems: AtpDataServiceEntities.IAtpItem[],
): IDataServiceRequest {
  const query = lTSGetATPDatesQuery();
  return query.createDataServiceRequestForOperation(
    "LTSGetATPDates",
    true,
    AtpDataServiceEntities.GetATPDatesResponseExtensionClass,
    "false",
    {
      bypassCache: "get",
      returnEntity: "DataServiceEntities.IGetATPDatesResponse",
    },
    {
      atpItems: atpItems,
    },
  );
}

export function lTSGetATPDatesAsync(
  context: IContext,
  atpItems: AtpDataServiceEntities.IAtpItem[],
): AsyncResult<AtpDataServiceEntities.IGetATPDatesResponse> {
  const request = lTSGetATPDatesInput(atpItems);
  return callActionOrExecute<AtpDataServiceEntities.IGetATPDatesResponse>(
    request,
    context.callerContext,
  );
}
